import React from 'react';

const NOTICE = 'To report misconduct by a driving instructor, call Transport for NSW on 131 500.';

function NoticeTicker() {
  const items = Array.from({length: 8});
  return (
    <div className="ticker" role="note" aria-label={NOTICE}>
      <div className="ticker-track" aria-hidden="true">
        {items.map((_, i) => (
          <span className="ticker-item" key={i}><b>NOTICE</b> {NOTICE}</span>
        ))}
      </div>
    </div>
  );
}

export default NoticeTicker;